import React, {Component} from 'react'
import ResetFilters from './ResetFilters'
import ExportData from './ExportData'
import PropTypes from "prop-types"

class OrdersReportActions extends Component {

    render() {
        const {filters, onResetFilters} = this.props

        return (
            <div className="OrdersReportActions d-flex align-items-center">
                <ResetFilters onResetFilters={onResetFilters}/>
                <ExportData filters={filters}/>
            </div>
        )
    }
}

OrdersReportActions.propTypes = {
    onResetFilters: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired
}

export default OrdersReportActions